import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useDetails } from "../../../../../context/details"
import { getReviewsData } from "../../../../../context/details/utils";

export const useReviews = () => {
  const { id } = useParams();
  const { detailsDispatch, data } = useDetails();
  const [reviewsData, setReviewsData] = useState<any>([]);
  const [reviewsIsLoading, setReviewsIsLoading] = useState(true);
  const [reviewsPage, setReviewsPage] = useState(1);
  const initalFetch = useRef(false);

  const handleTabChange = (id: number) => {
    detailsDispatch({
      type: "setActiveTab",
      data: {
        id,
        name: ""
      }
    })
  }

  const redirectToCoreProfile = () => {
    if (data && data.redirectLink) {
      window.open(`${window.location.origin}${data.redirectLink}`, "_blank")
    }
  }

  const handleNextPage = () => {
    if (data) {
      if (reviewsData.length < data.ratingCount) {
        setReviewsPage(reviewsPage + 1);
      }
    }
  }

  useEffect(() => {
    if ((data && data.reviewUrl) && (!initalFetch.current || reviewsPage > 1)) {
      setReviewsIsLoading(true);
      initalFetch.current = true;
      getReviewsData(data.reviewUrl, reviewsPage, data.itemType.toLowerCase()).then((res) => {
        setReviewsData([...reviewsData, ...res]);
        setReviewsIsLoading(false);
      })
    }
  }, [data, reviewsPage])

  useEffect(() => {
    setReviewsData([]);
    setReviewsIsLoading(true);
    setReviewsPage(1);
  }, [id])


  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return {
    handleTabChange,
    reviewSummary: {
      rating: data?.rating || 0,
      ratingCount: data?.ratingCount || 0
    },
    redirectToCoreProfile,
    handleNextPage,
    reviewsIsLoading,
    reviewsData
  }
}
